<template>
    <div class="consultation-actions">
        <button class="btn btn--danger" @click="cancelOpen = true">Отменить личную сессию</button>
        <button class="btn btn--primary" @click="rescheduleOpen = true">Перенести личную сессию</button>
        <button class="btn" @click="noShowOpen = true">Отметить неявку</button>

        <CancelConsultationDialog
            v-if="cancelOpen"
            :open="cancelOpen"
            :order-item-id="orderItemId"
            @close="cancelOpen = false"
            @done="onDone"
        />

        <RescheduleDialog
            v-if="rescheduleOpen"
            :open="rescheduleOpen"
            :order-item-id="orderItemId"
            @close="rescheduleOpen = false"
            @done="onDone"
        />

        <dialog v-if="noShowOpen" :open="noShowOpen" class="action-dialog">
            <h3>Отметить неявку</h3>
            <label>Кто не явился
                <select v-model="noShowActor">
                    <option value="mentor">Наставник</option>
                    <option value="mentee">Ученик</option>
                </select>
            </label>
            <label>Примечания
                <textarea v-model="noShowNotes" rows="3" />
            </label>
            <div class="actions">
                <button class="btn btn--primary" :disabled="busy" @click="submitNoShow">
                    {{ busy ? 'Отправляю…' : 'Отметить' }}
                </button>
                <button class="btn" @click="noShowOpen = false">Отмена</button>
            </div>
        </dialog>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import CancelConsultationDialog from './CancelConsultationDialog.vue';
import RescheduleDialog from './RescheduleDialog.vue';

const props = defineProps<{ detail: { id: number | string } }>();

const cancelOpen = ref(false);
const rescheduleOpen = ref(false);
const noShowOpen = ref(false);
const noShowActor = ref<'mentor' | 'mentee'>('mentee');
const noShowNotes = ref('');
const busy = ref(false);

// V2 hard cutover: the generic-admin record is now an OrderItem
// (OrderItem.public_id), not a ConsultationBooking. The detail id is the
// canonical orderItemId the V2 admin actions resolve.
const orderItemId = (): string => String(props.detail.id);

async function submitNoShow(): Promise<void> {
    busy.value = true;
    try {
        // TODO(v2-cutover): the /admin-api/consultation-bookings/<id>/mark-no-show/
        // endpoint was removed with the ConsultationBooking model. Re-point at the
        // V2 admin Conference no-show action (BespokeConferencesViewSet sets
        // Conference.status = NO_SHOW_MENTOR/MENTEE) resolved from the OrderItem,
        // i.e. POST /admin-api/conferences/<conference_id>/mark-no-show/. Requires
        // BE coordination to expose orderItemId -> conference resolution.
        await request({
            method: 'post',
            url: `/admin-api/conferences/${orderItemId()}/mark-no-show/`,
            data: { actor: noShowActor.value, notes: noShowNotes.value },
        });
        noShowOpen.value = false;
        onDone();
    } finally {
        busy.value = false;
    }
}

function onDone(): void {
    cancelOpen.value = false;
    rescheduleOpen.value = false;
    noShowOpen.value = false;
    window.location.reload();
}
</script>

<style scoped>
.consultation-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}
.action-dialog {
    padding: 1.5rem;
    border-radius: var(--admin-radius-sm);
    border: 1px solid var(--admin-border);
    box-sizing: border-box;
    /* только max-width: на десктопе диалог остаётся fit-content, как был */
    max-width: min(440px, 92vw);
    max-height: 90vh;
    overflow-y: auto;
}
.action-dialog label {
    display: block;
    margin-bottom: 0.75rem;
}
.actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

@media (max-width: 640px) {
    /* iOS зумит страницу при фокусе, если шрифт поля меньше 1rem */
    .action-dialog textarea,
    .action-dialog select { width: 100%; box-sizing: border-box; font-size: 1rem; }
    .action-dialog select { min-height: 2.5rem; }
    .actions .btn { min-height: 2.5rem; }
    .consultation-actions .btn { min-height: 2.5rem; }
}
</style>
